import { useTranslate } from '~/i18n';

const TabbyWidget = ({
   price,
   installments = 4,
   elementId = 'tabby-info',
}: {
   price: string | number;
   installments?: number;
   elementId?: string;
}) => {
   const { locale } = useTranslate();
   setTimeout(() => {
      if (typeof window !== 'undefined' && (window as any)?.TabbyPromo) {
         new (window as any).TabbyPromo({
            selector: `#${elementId}`,
            currency: 'SAR',
            price,
            installmentsCount: installments,
            lang: locale,
            source: 'product',
         });
      }
   }, 300);

   return <div id={elementId}></div>;
};
export default TabbyWidget;
